import {
  VIBE_CODING_WORKSPACE_BEGIN,
  VIBE_CODING_WORKSPACE_SUCCESS,
  VIBE_CODING_WORKSPACE_FAILURE,
  VIBE_CODING_WORKSPACE_FILE_BEGIN,
  VIBE_CODING_WORKSPACE_FILE_SUCCESS,
  VIBE_CODING_WORKSPACE_FILE_FAILURE,
  VIBE_CODING_WORKSPACE_SAVE_BEGIN,
  VIBE_CODING_WORKSPACE_SAVE_SUCCESS,
  VIBE_CODING_WORKSPACE_SAVE_FAILURE,
} from './constants';
import {
  fetchWorkspace,
  fetchWorkspaceFile,
  updateWorkspaceFile,
} from '../services/vibeCodingService';
import {
  createRequestId,
  matchesRequest,
} from '../../../features-v2/vibe-coding/utils/requestUtils';

const createWorkspaceRequestId = () => createRequestId('vibe-workspace');

const matchesWorkspaceRequest = (state, meta = {}) =>
  matchesRequest(state.activeWorkspaceRequestId, meta.requestId);

export const getWorkspace =
  (args = {}) =>
  async (dispatch) => {
    const requestId = createWorkspaceRequestId();
    dispatch({ type: VIBE_CODING_WORKSPACE_BEGIN, meta: { requestId } });
    try {
      const data = await fetchWorkspace(args);
      dispatch({
        type: VIBE_CODING_WORKSPACE_SUCCESS,
        data,
        meta: { requestId },
      });
      return data;
    } catch (error) {
      dispatch({
        type: VIBE_CODING_WORKSPACE_FAILURE,
        data: { error },
        meta: { requestId },
      });
      throw error;
    }
  };

export const getWorkspaceFile =
  (args = {}) =>
  async (dispatch) => {
    dispatch({ type: VIBE_CODING_WORKSPACE_FILE_BEGIN, data: args.path });
    try {
      const data = await fetchWorkspaceFile(args);
      dispatch({ type: VIBE_CODING_WORKSPACE_FILE_SUCCESS, data });
      return data;
    } catch (error) {
      dispatch({ type: VIBE_CODING_WORKSPACE_FILE_FAILURE, data: { error } });
      throw error;
    }
  };

export const saveWorkspaceFile =
  (args = {}) =>
  async (dispatch) => {
    dispatch({ type: VIBE_CODING_WORKSPACE_SAVE_BEGIN });
    try {
      const data = await updateWorkspaceFile(args);
      dispatch({ type: VIBE_CODING_WORKSPACE_SAVE_SUCCESS, data });
      return data;
    } catch (error) {
      dispatch({ type: VIBE_CODING_WORKSPACE_SAVE_FAILURE, data: { error } });
      throw error;
    }
  };

export function reducer(state, action) {
  const meta = action.meta || {};
  switch (action.type) {
    case VIBE_CODING_WORKSPACE_BEGIN:
      return {
        ...state,
        workspacePending: true,
        workspaceError: null,
        activeWorkspaceRequestId: meta.requestId || state.activeWorkspaceRequestId,
      };
    case VIBE_CODING_WORKSPACE_SUCCESS:
      if (!matchesWorkspaceRequest(state, meta)) return state;
      return {
        ...state,
        workspacePending: false,
        workspaceError: null,
        workspace: action.data,
        workspaceFiles: Object.fromEntries(
          (action.data.files || []).map((file) => [file.path, file]),
        ),
      };
    case VIBE_CODING_WORKSPACE_FAILURE:
      if (!matchesWorkspaceRequest(state, meta)) return state;
      return { ...state, workspacePending: false, workspaceError: action.data.error };
    case VIBE_CODING_WORKSPACE_FILE_BEGIN:
      return {
        ...state,
        workspaceFilePending: true,
        workspaceSelectedPath: action.data,
        workspaceError: null,
      };
    case VIBE_CODING_WORKSPACE_FILE_SUCCESS:
      return {
        ...state,
        workspaceFilePending: false,
        workspaceFile: action.data,
        workspaceError: null,
      };
    case VIBE_CODING_WORKSPACE_FILE_FAILURE:
      return { ...state, workspaceFilePending: false, workspaceError: action.data.error };
    case VIBE_CODING_WORKSPACE_SAVE_BEGIN:
      return {
        ...state,
        workspaceSavePending: true,
        workspaceConflict: false,
        workspaceSaveError: null,
      };
    case VIBE_CODING_WORKSPACE_SAVE_SUCCESS:
      return {
        ...state,
        workspaceSavePending: false,
        workspaceConflict: false,
        workspaceSaveError: null,
        workspaceError: null,
        workspaceFile: { ...state.workspaceFile, ...action.data },
      };
    case VIBE_CODING_WORKSPACE_SAVE_FAILURE: {
      const isConflict = Boolean(
        action.data.error &&
          action.data.error.response &&
          action.data.error.response.status === 409,
      );
      return {
        ...state,
        workspaceSavePending: false,
        workspaceConflict: isConflict,
        workspaceSaveError: isConflict ? null : action.data.error,
      };
    }

    default:
      return state;
  }
}
